import {
  cellStyles3,
  cellStyles4,
  Columns,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import {
  dropDownMenuItemsAlphabets,
  dropDownMenuItemsValues,
} from '../../core-utils/helper-utils/tableSortHelper';
export const columns: Columns[] = [
  {
    name: 'Disease Category',
    align: 'left',
    cellStyles: cellStyles4,
    width: '350px',
    sortColumnName: 'condition',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsAlphabets,
  },
  {
    name: 'Total Cost',
    align: 'left',
    cellStyles: { ...cellStyles3, padding: '8px 56px 8px 20px' },
    width: '100px',
    sortColumnName: 'totalCost',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsValues,
  },
  {
    name: 'Current Members',
    align: 'left',
    cellStyles: cellStyles4,
    width: '130px',
    sortColumnName: 'currentMembers',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsValues,
  },
  {
    name: 'Previous Members',
    align: 'left',
    cellStyles: cellStyles4,
    width: '130px',
    sortColumnName: 'previousMembers',
    showThisColumn: true,
    DropDownMenuItems: dropDownMenuItemsValues,
  },
  //To be added when implemented
  // {
  //   name: 'Risk',
  //   align: 'left',
  //   cellStyles: cellStyles4,
  //   width: '40px',
  // },
];
